const appLoginLogo = require('../static/img/icon/birlesik-logo.png');
const appHeaderLogo = require('../static/img/birlesik-white.png');

const images = {
  'app-login-logo': appLoginLogo,
  'app-header-logo': appHeaderLogo,
};

export default images;
